import { Navigate, createFileRoute } from '@tanstack/react-router';
import { useAslen, useMyInvitations } from '@aslen/core/hooks';
import { SkeletonRows } from '@/components/ui/display';
import { SetupWizard } from '@/features/onboarding/setup-wizard';

export const Route = createFileRoute('/setup')({
  component: function Setup() {
    const { session, authReady, membershipsLoading, companyId } = useAslen();
    const invitations = useMyInvitations();
    if (!authReady || membershipsLoading) return <SkeletonRows rows={8} />;
    if (!session) return <Navigate to="/login" />;
    // someone invited to an existing company must join it, not create a second one
    if (!companyId) {
      if (invitations.isLoading) return <SkeletonRows rows={8} />;
      const first = invitations.data?.[0];
      if (first) return <Navigate to="/invite" search={{ token: first.token }} />;
    }
    return <SetupWizard />;
  },
});
